import { Nullable } from "@core/domain/types/nullable.type";
import { CostTypeEnumDto } from "@entity/data/dto/cost/cost-type.dto";
import { CostTypeEnum } from "@entity/domain/models/cost/cost-type.model";
import { injectable } from "inversify";

@injectable()
export class CostTypeEnumMapper {
    map(costTypeEnumDto: CostTypeEnumDto): Nullable<CostTypeEnum> {
        switch (costTypeEnumDto) {
            case CostTypeEnumDto.TRAVEL:
                return CostTypeEnum.TRAVEL;
            case CostTypeEnumDto.PERSONNEL_MANAGEMENT_ADMINISTRATION:
                return CostTypeEnum.PERSONNEL_MANAGEMENT_ADMINISTRATION;
            case CostTypeEnumDto.MAINTENANCE_ACTIVITIES:
                return CostTypeEnum.MAINTENANCE_ACTIVITIES;
            case CostTypeEnumDto.INVESTMENT:
                return CostTypeEnum.INVESTMENT;
            case CostTypeEnumDto.MANAGEMENT_ADMINISTRATION:
                return CostTypeEnum.MANAGEMENT_ADMINISTRATION;
            case CostTypeEnumDto.OTHER_SUBSIDIZABLE_EXPENSES:
                return CostTypeEnum.OTHER_SUBSIDIZABLE_EXPENSES;
            default:
                return null;
        }
    }

    mapToDto(costTypeEnum: CostTypeEnum): CostTypeEnumDto {
        switch (costTypeEnum) {
            case CostTypeEnum.TRAVEL:
                return CostTypeEnumDto.TRAVEL;
            case CostTypeEnum.PERSONNEL_MANAGEMENT_ADMINISTRATION:
                return CostTypeEnumDto.PERSONNEL_MANAGEMENT_ADMINISTRATION;
            case CostTypeEnum.MAINTENANCE_ACTIVITIES:
                return CostTypeEnumDto.MAINTENANCE_ACTIVITIES;
            case CostTypeEnum.INVESTMENT:
                return CostTypeEnumDto.INVESTMENT;
            case CostTypeEnum.MANAGEMENT_ADMINISTRATION:
                return CostTypeEnumDto.MANAGEMENT_ADMINISTRATION;
            case CostTypeEnum.OTHER_SUBSIDIZABLE_EXPENSES:
                return CostTypeEnumDto.OTHER_SUBSIDIZABLE_EXPENSES;
            default:
                throw new Error(`Unknown CostTypeEnum: ${costTypeEnum}`);
        }
    }
}